export default __webpack_public_path__ + "static/media/pictogramBeaconCurrency48.3536505d.svg";